export const checkStatusIn = (currentStatus: string, statuses: string[]): boolean => {
    return statuses.includes(currentStatus);
};
